import {
  Box,
  Text,
  Flex,
  Checkbox,
  FormControl,
  Input,
  FormHelperText,
  FormLabel,
} from "@chakra-ui/react";
import React, { useState } from "react";

const DisplayInvitationCard = () => {
  const accessToken = localStorage.getItem("token");
  const imagePreview = localStorage.getItem("imagePreview");
  const preview = localStorage.getItem("previewId");
  const [isChecked, setIsChecked] = useState(false);
  const [eventid, setEventId] = useState(0);

  //   Event Option Request DTO
  const [accomodation, setAccomodation] = useState(false);
  const [flight, setflight] = useState(false);
  const [requestRSVP, setRequestRSVP] = useState(false);
  const [allowCommentsWall, setCommentsWall] = useState(false);
  const [authorizeMemeberToManage, setAuthorizeMemberToManage] =
    useState(false);
  const [eshagunFlag, setEshagunFlag] = useState(false);

  //   EventRequestDTO
  const [eventName, setEventName] = useState("");
  const [eventType, setEventType] = useState("");
  const [eventDetails, setEventDetails] = useState("");
  const [eventTiming, setEventTiming] = useState("");
  const [eventVenue, setEventVenue] = useState("");
  const [venuePincode, setVenuePincode] = useState("");
  const [expectedNoOfGuests, setexpectedNoOfGuests] = useState("");
  const [venueImg, setVenueImg] = useState("");

  //   authorizeMemberList
  const [authorizeMemberName, setAuthorizeMemberName] = useState("");
  const [authorizeMemberMobileNo, setAuthorizeMemberMemberNo] = useState("");

  const [eshagunUPI, setEshagunUPI] = useState("");

  //   invitationHistoryRequestDto
  const [templateId, settemplateId] = useState("");
  const [previewImage, setPreviewImage] = useState(imagePreview);
  const [sourceMediaId, setSourceMediaId] = useState("");
  const [sharingModeType, setSharingModeType] = useState("");
  const [invitationDetails, setInvitationDetails] = useState(null);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleSubmit = () => {
    console.log(`eventid`, eventid);
  };

  return (
    <Box border={"2px"} h={"900"}>
      <Flex flexDir={{ base: "column-reverse", md: "row" }}>
        <Box border={"2px"} w={{ base: "100%", md: "60%" }}>
          <Box
            color={"#3C375F"}
            fontStyle={"Sans-serif"}
            fontSize={{ base: "20", md: "28", lg: "28" }}
            fontWeight={"Bold"}
            textAlign={"left"}
            ml={"5"}
          >
            {" "}
            Send Invitation
          </Box>

          <Box>
            <Box textAlign={"left"} ml={"5"} mt={"10"}>
              <Checkbox
                color={"#200E32"}
                fontFamily={"Lato, sans-serif"}
                fontStyle={"regular"}
                isChecked={isChecked}
                onChange={handleCheckboxChange}
              >
                Allow person to view invitation with invitation link
              </Checkbox>
            </Box>

            <Box>
              <Text
                textAlign={"left"}
                ml={"5"}
                mt={"10"}
                fontSize={"18px"}
                fontFamily={"Lato, sans-serif"}
                color={"#200E32"}
              >
                Event Details
              </Text>
              <Box display={"flex"} flexDir={"column"}>
                <Box display={"flex"} flexDir={"column"}>
                  <FormControl>
                    <FormLabel htmlFor="eventId">Event ID</FormLabel>
                    <Input
                      type="text"
                      placeholder={eventid}
                      border="1px solid gray"
                      w="50%"
                      id="eventId"
                      name="likes"
                      onChange={(e) => setEventId(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSubmit();
                        }
                      }}
                      textAlign="center"
                      fontWeight="bold"
                      margin="auto"
                    />
                  </FormControl>
                  <Box mt={"5"}>
                    <FormControl>
                      <FormLabel htmlFor="eventName">Event Name</FormLabel>
                      <Input
                        type="text"
                        placeholder={eventName}
                        border="1px solid gray"
                        w="50%"
                        id="eventName"
                        name="likes"
                        onChange={(e) => setEventName(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit();
                          }
                        }}
                        textAlign="center"
                        fontWeight="bold"
                        margin="auto"
                      />
                    </FormControl>
                  </Box>
                  <Box mt={"5"}>
                    <FormControl>
                      <FormLabel htmlFor="eventName">Event </FormLabel>
                      <Input
                        type="text"
                        placeholder={eventName}
                        border="1px solid gray"
                        w="50%"
                        id="eventName"
                        name="likes"
                        onChange={(e) => setEventName(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit();
                          }
                        }}
                        textAlign="center"
                        fontWeight="bold"
                        margin="auto"
                      />
                    </FormControl>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box border={"2px"} w={{ base: "100%", md: "60%" }}>
          Image
        </Box>
      </Flex>
    </Box>
  );
};

export default DisplayInvitationCard;
